export const FRANCHISE_TYPE = {
  FULL_SERVICE: 'Full-service',
  MARKETPLACE: 'Marketplace',
};

export const OPERATING_MODELS = new Map([
  [1, { value: 'OWN_UNIT', name: 'Operação Própria', },],
  [2, { value: 'PROVISORY_OWN_UNIT', name: 'Operação Própria Provisória', },],
  [3, { value: 'B2B', name: 'B2B', },],
  [4, { value: 'ACCELERATED', name: 'Acelerada', },],
  [5, { value: '70_30', name: '70/30', },],
],);
